// extracted by mini-css-extract-plugin
module.exports = {"formConatiner":"FormBooks_formConatiner__4kGeG","formTitle":"FormBooks_formTitle__2Zvqy","background":"FormBooks_background__8hc8J","submitbtn":"FormBooks_submitbtn__31LiD"};